import { Button } from "@alpacahq/ui/old";

import type { ContraTransferType } from "~/v2/api/rest/acats";
import { TransferTypeButton } from "./TransferTypeButton";

interface FullTransferFormProps {
  onTransferTypeSelected: (type: ContraTransferType) => void;
  onPreviousClicked: () => void;
}

export const FullTransferForm = ({
  onTransferTypeSelected,
  onPreviousClicked,
}: FullTransferFormProps) => (
  <form
    className="flex w-full max-w-md flex-col gap-5"
    // Form is submitted by clicking buttons, no submit button
    onSubmit={(event) => event.preventDefault()}
  >
    <div className="flex flex-col gap-3">
      <h2 className="sr-only">
        Do you want to do a full transfer or transfer selected assets?
      </h2>
      <TransferTypeButton
        label="Full Transfer"
        onClick={() => onTransferTypeSelected("FULL")}
      />
      <TransferTypeButton
        label="Transfer Selected Assets"
        onClick={() => onTransferTypeSelected("PARTIAL")}
      />
    </div>
    <Button
      variant="v2/stroke"
      type="button"
      onClick={onPreviousClicked}
      className="w-fit"
    >
      Previous
    </Button>
  </form>
);
